import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const FieldArrayCards = ({
  name,
  push,
  children,
}) => (
  <FieldArrayIterables
    name={name}
    push={push}
  >
    {(r, i, helpers) => (
      <div className="card mb-3" key={i}>
        <button
          className="btn btn-link close"
          onClick={() => helpers.remove(i)}
        >
          <FA icon={faTimes} size="sm" />
        </button>
        <div className="card-body">
          {children(r, i, helpers)}
        </div>
      </div>
    )}
  </FieldArrayIterables>
);

export default FieldArrayCards;
